import { AuthenticatedFetchErrorJSON } from '../../../Common/Definitions';
import { NetworkLocation, StoreConfiguration } from '../../../Common/TypeDefinitions';
import { HTTPFetchResponse, HeadersJson } from '../../../utils/http/Http';
import { AuthBridgeBase } from './AuthBridgeBase';
import {
	AuthFetchMessage,
	AuthFetchWrapperMessage,
	GatewayAuthenticatedFetchMessage,
	GatewayAuthenticatedFetchWrapperMessage,
	GetGatewayRoamingAccountsResponseMessage,
	GetStoreConfigurationMessage,
	SetReferenceUriToGatewaySessionMessage,
	GetNetworkLocationMessage,
	EvaluateNetworkLocationAndStoreConfigurationMessage,
	GetNetworkLocationForURLMessage,
} from './BridgeInterfaceMessage';

export class AccountConfigToAuthNativeBridge extends AuthBridgeBase {
	private static _instance: AccountConfigToAuthNativeBridge;

	private constructor() {
		super();
	}

	static get Instance(): AccountConfigToAuthNativeBridge {
		return (
			AccountConfigToAuthNativeBridge._instance ||
			(AccountConfigToAuthNativeBridge._instance = new AccountConfigToAuthNativeBridge())
		);
	}

	public async gatewayAuthenticatedFetch(params: string): Promise<HTTPFetchResponse> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GatewayAuthenticatedFetchMessage = {
				type: 'call',
				id,
				name: 'gatewayAuthenticatedFetch',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async getGatewayRoamingAccountsResponse(
		url: string
	): Promise<HTTPFetchResponse> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GetGatewayRoamingAccountsResponseMessage = {
				type: 'call',
				id,
				name: 'getGatewayRoamingAccountsResponse',
				params: url,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public setReferenceUriToGatewaySession(
		sessionUrl: URL,
		referenceUri: string
	): Promise<boolean> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: SetReferenceUriToGatewaySessionMessage = {
				type: 'call',
				id,
				name: 'setReferenceUriToGatewaySession',
				params: { sessionUrl, referenceUri },
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async authFetch(
		method: string,
		url: string,
		headers: HeadersJson,
		body: string,
		referenceUri: string,
		allowCredUi: boolean,
		identifier?: string
	): Promise<HTTPFetchResponse> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: AuthFetchMessage = {
				type: 'call',
				id,
				name: 'authFetch',
				params: { method, url, headers, body, referenceUri, allowCredUi, id: identifier },
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async gatewayAuthenticatedFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GatewayAuthenticatedFetchWrapperMessage = {
				type: 'call',
				id,
				name: 'gatewayAuthenticatedFetchWrapper',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async authFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: AuthFetchWrapperMessage = {
				type: 'call',
				id,
				name: 'authFetchWrapper',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async getStoreConfiguration(): Promise<StoreConfiguration> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GetStoreConfigurationMessage = {
				type: 'call',
				id,
				name: 'getStoreConfiguration',
				params: {},
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async getNetworkLocation(params: string): Promise<NetworkLocation> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GetNetworkLocationMessage = {
				type: 'call',
				id,
				name: 'getNetworkLocation',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async getNetworkLocationForURL(params: string): Promise<NetworkLocation> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: GetNetworkLocationForURLMessage = {
				type: 'call',
				id,
				name: 'getNetworkLocationForURL',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}

	public async evaluateNetworkLocationAndStoreConfiguration(
		params: string
	): Promise<void> {
		return new Promise((resolve, reject) => {
			const id = this.addRequestToQueue(resolve, reject);
			const message: EvaluateNetworkLocationAndStoreConfigurationMessage = {
				type: 'call',
				id,
				name: 'evaluateNetworkLocationAndStoreConfiguration',
				params: params,
			};
			window.messageToNative(JSON.stringify(message));
		});
	}
}
